import { get } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"

export const getUserAgreementsList = () => get(url.USER_AGREEMENTS)